import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Import your translation files
import translationUZ from './locales/uz/translation.json';
import translationRU from './locales/ru/translation.json';

const resources = {
  uz: {
    translation: translationUZ,
  },
  ru: {
    translation: translationRU,
  },
};

// Get initial language from URL path if available
const getInitialLanguage = () => {
  const pathSegments = window.location.pathname.split('/');
  const langFromPath = pathSegments[1];

  if (langFromPath && ['uz', 'ru'].includes(langFromPath)) {
    return langFromPath;
  }

  // Fallback to localStorage or default
  const storedLang = localStorage.getItem('i18nextLng');
  if (storedLang && ['uz', 'ru'].includes(storedLang)) {
    return storedLang;
  }

  return 'uz';
};

// Create i18n instance
const i18n = i18next.createInstance({
  resources,
  fallbackLng: 'uz',
  debug: process.env.NODE_ENV === 'development',
  lng: getInitialLanguage(), // Set initial language from URL or localStorage
  supportedLngs: ['uz', 'ru'], // Explicitly define supported languages

  interpolation: {
    escapeValue: false, // React already safes from XSS
  },

  // Language detection options - prioritize URL over localStorage
  detection: {
    order: ['querystring', 'path', 'localStorage', 'navigator'],
    lookupQuerystring: 'lng',
    lookupPath: 'lang',
    lookupLocalStorage: 'i18nextLng',
    caches: ['localStorage'],
    // Don't automatically detect language on init
    checkWhitelist: true,
  },
});

// Initialize i18n with plugins
i18n.use(Backend).use(LanguageDetector).use(initReactI18next);

// Export a promise that resolves when i18n is initialized
export const i18nInit = i18n.init();

export default i18n;
